import { css, jsx } from '@emotion/react';
import { Animation, Link, Typography } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { useUniversalNavContext } from '../../../../hooks/useUniversalNavContext';
import { emitUserInteractionEvent } from '../../../../utils/avroEvents';
import { ArrowLinkIcon } from '../..';
const Styles = labelStyles('SubMenuList', {
    root: css({
        display: 'flex',
        flexDirection: 'column',
    }),
    item: {
        marginBottom: '10px',
        font: `var(--zds-body-1, 400 14px/24px ${Typography.base.fontFamily})`,
        '&:last-child': {
            marginBottom: 0,
        },
        '&:focus-within': {
            outline: `1px solid var(--zds-ui-primary-strongest, #503EBD)`,
        },
    },
    link: css({
        color: 'var(--zds-gray-warm-9, #413735)',
        font: `var(--zds-body-1, 400 14px/24px ${Typography.base.fontFamily})`,
        position: 'relative',
        textDecoration: 'none',
        transition: `text-decoration 100ms ${Animation.transitionTimingFunction}`,
        '&:hover': {
            textDecoration: 'underline',
        },
        '&:hover > span': {
            marginLeft: 4,
            opacity: 1,
        },
        '&:focus': {
            outline: 'none',
        },
    }),
});
export const SubMenuList = (props) => {
    const { submenu } = props;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const emitEvent = (link, eventType) => {
        var _a;
        emitUserInteractionEvent({
            event_action: eventType,
            interaction_name: `universal_nav_submenu_link_${eventType}`,
            option_selected: link.text,
            interaction_raw_text: link.text,
            destination_href: (_a = link.href) !== null && _a !== void 0 ? _a : '',
            custom_tracking_fields: { parent: props.parent },
        });
    };
    const handleLinkClick = (link) => {
        var _a;
        (_a = props.onCloseMenu) === null || _a === void 0 ? void 0 : _a.call(props);
        emitEvent(link, 'click');
    };
    const handleLinkHover = (link) => {
        emitEvent(link, 'hover');
    };
    return (jsx("ul", { css: Styles.root, "data-zds": true }, submenu.map((link, index) => (jsx("li", { css: Styles.item, key: `${link.text}-${index}`, "data-zds": true },
        jsx(Link, { css: Styles.link, color: null, href: getFullyQualifiedURL(link.href) || undefined, onClick: () => handleLinkClick(link), onMouseEnter: () => handleLinkHover(link), target: link.target },
            link.text,
            jsx(ArrowLinkIcon, null)))))));
};
//# sourceMappingURL=SubMenuList.js.map
// @zapier/universal-layout@9.14.0 (b13df7b0f)
